const ROLES = {
  host: { label: "You're the Host", cls: "bg-rose-500/20 text-rose-100 border-rose-400/50" },
  speaker: { label: "You're a Speaker", cls: "bg-emerald-500/20 text-emerald-100 border-emerald-400/50" },
  listener: { label: "You're a Listener", cls: "bg-white/5 text-pink-100 border-white/15" },
  guest: { label: "Listening as a guest", cls: "bg-white/5 text-pink-100/80 border-white/10" },
};

export const BeamRoleBadge = ({ role }) => {
  const r = ROLES[role] || ROLES.listener;
  return (
    <span className={`text-[11px] font-bold px-2.5 py-1 rounded-full border whitespace-nowrap ${r.cls}`} data-testid="live-room-my-role" data-role={role}>
      {r.label}
    </span>
  );
};

export const BeamKindBadge = ({ kind }) => (
  <span className="text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full bg-purple-500/20 text-purple-100 border border-purple-400/40" data-testid="beam-kind-badge">
    {kind === "audio" ? "🎧 Audio Beam" : "🎥 Live Beam"}
  </span>
);
